import { render, staticRenderFns } from "./fields-list-modal.vue?vue&type=template&id=1007ac68&"
import script from "./fields-list-modal.vue?vue&type=script&lang=js&"
export * from "./fields-list-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports